/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Tile_Voided_HintInputs */



/**
* | output |
* | --- |
* | "Cancelled — never counted as payable" |
*
* @param {Partner_Admin_Commission_Tile_Voided_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_tile_voided_hint = /** @type {((inputs?: Partner_Admin_Commission_Tile_Voided_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Tile_Voided_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Storniert — nie als zahlbar gezählt")
	return /** @type {LocalizedString} */ ("Cancelled — never counted as payable")
});